module.exports = __webpack_public_path__ + "site/img/payment_FPS.ffb2c835.png";